import { LatLngExpression } from 'leaflet';

// Gaza's actual center coordinates
export const GAZA_CENTER = {
  lat: 31.5,
  lng: 34.45
};

// Transform a coordinate from Gaza's actual location to the overlay position
export function transformCoordinate(
  originalLat: number,
  originalLng: number,
  overlayCenter: LatLngExpression | null
): [number, number] | null {
  if (!overlayCenter) return null;
  
  const [targetLat, targetLng] = Array.isArray(overlayCenter)
    ? overlayCenter
    : [overlayCenter.lat, overlayCenter.lng];

  // Calculate offset from Gaza's center
  const latOffset = originalLat - GAZA_CENTER.lat;
  const lngOffset = originalLng - GAZA_CENTER.lng;

  // Apply offset to overlay position
  return [
    targetLat + latOffset,
    targetLng + lngOffset
  ];
}

// Transform an array of coordinates
export function transformCoordinates(
  coordinates: Array<[number, number]>,
  overlayCenter: LatLngExpression | null
): Array<[number, number]> {
  if (!overlayCenter) return [];
  
  return coordinates.map(([lat, lng]) => {
    const transformed = transformCoordinate(lat, lng, overlayCenter);
    return transformed || [lat, lng];
  });
}